export interface IAddress {
	addressLine1: string;
	addressLine2: string;
	state: string;
	city: string;
	zip: string;
	latitude: number;
	longitude: number;
}

// Describes a physical address.
export class Address implements IAddress {
	// The address type.
	public addressType: string;
	// The first line of the street address.
	public addressLine1: string;
	// The second line of the street address.
	public addressLine2: string;
	// The state for the address.
	public state: string;
	// The city for the address.
	public city: string;
	// The ZIP code for the address.
	public zip: string = "";
	// The country for the address.
	public country: string = "";
	// The address latitude.
	public latitude: number;
	// The address longitude.
	public longitude: number;
}
